export default __webpack_public_path__ + "static/lozenge-dropdown-dont-1-dark-c7210f8d1cf674047a008c903e880a96e2604c6e7dee94b4f6ff30947858406e.png";